import axios from 'axios';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// Auth
export const loginApi = (username, password) =>
  api.post('/auth/login', { username, password });
export const changePassword = (current_password, new_password) =>
  api.put('/auth/password', { current_password, new_password });
export const getSetupStatus = () => api.get('/auth/setup-status');
export const setupAdmin = (username, password) =>
  api.post('/auth/setup', { username, password });

// Site Settings (public)
export const getSiteSettings = () => api.get('/settings/site');
export const updateSiteSettings = (data) => api.put('/settings/site', data);

// Logs
export const getLogs = (type, limit = 100) =>
  api.get('/logs', { params: { type, limit } });
export const clearLogs = () => api.delete('/logs');

// Rooms
export const getRooms = () => api.get('/rooms');
export const createRoom = (data) => api.post('/rooms', data);
export const updateRoom = (id, data) => api.put(`/rooms/${id}`, data);
export const deleteRoom = (id) => api.delete(`/rooms/${id}`);

// Devices
export const getDevices = (roomId) =>
  api.get('/devices', { params: roomId ? { room_id: roomId } : {} });
export const createDevice = (data) => api.post('/devices', data);
export const updateDevice = (id, data) => api.put(`/devices/${id}`, data);
export const deleteDevice = (id) => api.delete(`/devices/${id}`);

// Relays — now device-aware
export const getRelays = (espDeviceId) =>
  api.get('/relays', { params: espDeviceId ? { esp_device_id: espDeviceId } : {} });
export const renameRelay = (num, name, espDeviceId = 'global') =>
  api.put(`/relays/${num}/name`, { name }, { params: { esp_device_id: espDeviceId } });
export const controlRelay = (relay_number, state, esp_device_id = 'global') =>
  api.post('/relays/control', { relay_number, state, esp_device_id });

// Settings
export const getEspSettings = () => api.get('/settings/esp');
export const updateEspSettings = (data) => api.put('/settings/esp', data);
export const regenerateEspKey = () => api.post('/settings/esp/regenerate-key');
export const getEspStatus = () => api.get('/esp/status');

export const controlAllRelays = (state) => api.post('/relays/control-all', { state });

// Schedules
export const getSchedules = () => api.get('/schedules');
export const createSchedule = (data) => api.post('/schedules', data);
export const updateSchedule = (id, data) => api.put(`/schedules/${id}`, data);
export const deleteSchedule = (id) => api.delete(`/schedules/${id}`);
export const toggleSchedule = (id) => api.post(`/schedules/${id}/toggle`);
export const runScheduleNow = (id) => api.post(`/schedules/${id}/run`);

// MQTT Settings
export const getMqttSettings = () => api.get('/settings/mqtt');
export const updateMqttSettings = (data) => api.put('/settings/mqtt', data);
export const getMqttStatus = () => api.get('/settings/mqtt/status');

// ESP Devices
export const getEspDevices = () => api.get('/esp/devices');
export const createEspDevice = (data) => api.post('/esp/devices', data);
export const updateEspDevice = (id, data) => api.put(`/esp/devices/${id}`, data);
export const deleteEspDevice = (id) => api.delete(`/esp/devices/${id}`);
export const regenerateDeviceKey = (id) => api.post(`/esp/devices/${id}/regenerate-key`);

// Relay Groups
export const getRelayGroups = () => api.get('/relay-groups');
export const createRelayGroup = (data) => api.post('/relay-groups', data);
export const updateRelayGroup = (id, data) => api.put(`/relay-groups/${id}`, data);
export const deleteRelayGroup = (id) => api.delete(`/relay-groups/${id}`);
export const controlRelayGroup = (id, state) => api.post(`/relay-groups/${id}/control`, { state });

// Analytics
export const getRelayAnalytics = (date) =>
  api.get('/analytics/relays', { params: date ? { date } : {} });

export const getAnalyticsTrend = (days) => api.get('/analytics/trend', { params: { days } });

// Users (Admin only)
export const getUsers = () => api.get('/users');
export const createUser = (data) => api.post('/users', data);
export const updateUser = (id, data) => api.put(`/users/${id}`, data);
export const deleteUser = (id) => api.delete(`/users/${id}`);

export default api;
